export function isAuthenticated(auth: AuthReducer.IState) {
  return auth && auth.token;
}